import React from 'react';
import { Ban, Clock, HelpCircle, Mic2 } from 'lucide-react';

export type QuickClientAction = 'niet_passend' | 'later' | 'meer_info' | 'interview';

const QuickActionButtons: React.FC<{
  onAction: (a: QuickClientAction) => void;
  disabled?: boolean;
  compact?: boolean;
}> = ({ onAction, disabled, compact }) => (
  <div
    className={`grid gap-2 ${compact ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 lg:grid-cols-4'}`}
    role="group"
    aria-label="Snelle acties"
  >
    <button
      type="button"
      disabled={disabled}
      onClick={() => onAction('niet_passend')}
      className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-2.5 text-xs font-bold text-slate-700 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-800 disabled:opacity-50"
    >
      <Ban className="h-4 w-4 shrink-0 text-red-500" aria-hidden />
      Niet passend
    </button>
    <button
      type="button"
      disabled={disabled}
      onClick={() => onAction('later')}
      className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-2.5 text-xs font-bold text-slate-700 shadow-sm transition hover:border-amber-200 hover:bg-amber-50 hover:text-amber-900 disabled:opacity-50"
    >
      <Clock className="h-4 w-4 shrink-0 text-amber-600" aria-hidden />
      Later beoordelen
    </button>
    <button
      type="button"
      disabled={disabled}
      onClick={() => onAction('meer_info')}
      className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-2.5 text-xs font-bold text-slate-700 shadow-sm transition hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-900 disabled:opacity-50"
    >
      <HelpCircle className="h-4 w-4 shrink-0 text-indigo-500" aria-hidden />
      Meer info nodig
    </button>
    <button
      type="button"
      disabled={disabled}
      onClick={() => onAction('interview')}
      className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white py-2.5 text-xs font-bold text-slate-700 shadow-sm transition hover:border-emerald-200 hover:bg-emerald-50 hover:text-emerald-900 disabled:opacity-50"
    >
      <Mic2 className="h-4 w-4 shrink-0 text-emerald-600" aria-hidden />
      Door naar interview
    </button>
  </div>
);

export default QuickActionButtons;
